import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../utils/store';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { Box, Paper, Typography } from '@mui/material';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import PaginateDataModel from '../../../Models/PaginateDataModel';
import { useAlert } from '../../../components/alertContext';
import { useNavigate } from 'react-router-dom';
import { getShiftStatusText } from '../../../utils/storageUtil';
interface ProjectShiftListProps {
  projectInternalId: number;
}
const ProjectShiftList: React.FC<ProjectShiftListProps> = ({
  projectInternalId,
}) => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const [searchQueryShift, setSearchQueryShift] = useState<any>('');
  const [totalRecordsShift, setTotalRecordsShift] = useState<number>(0);
  const [shiftList, setShiftList] = useState<any>([]);
  const navigate = useNavigate();
  const [paginateShiftList, setPaginateShiftList] = useState<PaginateDataModel>(
    {
      limit: -1,
      offset: 0,
    }
  );
  const columns: any[] = [
    {
      field: 'date',
      headerName: 'Shift Date',
    },
    {
      field: 'siteAddress',
      headerName: 'Site Address',
    },
    {
      field: 'id',
      headerName: 'Crew',
      renderCell: (value: any, row: any) => row.crew.name,
    },
    {
      field: 'shiftStatusId',
      headerName: 'Shift Status',
      width: '100px',
      renderCell: (value: any, row: any) => (
        <Box
          style={{
            backgroundColor: '#001e3c',
            color: '#00e5ff',
            borderRadius: '25px',
            fontWeight: 600,
            padding: '4px 8px',
            fontSize: '12px',
            width: '90%',
            textAlign: 'center',
          }}
        >
          {getShiftStatusText(value)}
        </Box>
      ),
    },
  ];

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });

  const { alert, setAlert, handleCloseAlert } = useAlert();
  const FetchShiftList = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.projectDashboardsURL}/${projectInternalId}/shift`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: searchQueryShift,
          limit: paginateShiftList.limit,
          offset: paginateShiftList.offset,
          isActive: 1,
        }
      );
      if (response.success) {
        setShiftList(response.data);
        setTotalRecordsShift(response.data.length);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handlePaginationShift = (paginationData: any) => {
    console.log(paginationData);
    setPaginateShiftList(paginationData);
  };

  useEffect(() => {
    if (paginateShiftList || isInitialLoad.current) {
      FetchShiftList();
    }
    isInitialLoad.current = false;
  }, [paginateShiftList]);

  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">All Shifts</Typography>
          </Box>
          <CustomPaginationActionsTable
            rows={shiftList}
            columns={columns}
            totalRecords={totalRecordsShift}
            handlePagination={handlePaginationShift}
            handleRowClick={(row) => {
              navigate(
                '/schedules/crews-schedule/' + row.crewId + '/' + row.shiftId
              );
            }}
            paginationModel={{
              page: paginateShiftList.offset,
              pageSize: paginateShiftList.limit,
            }}
            handleStatus={() => {}}
            isPagingHide={true}
          />

          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ProjectShiftList;
